import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { CartEvent } from "@/global/store/data/purchaseSeats/cartManager";
import { ModalActionButton } from "@/shared/base/components/ModalActionButton/ModalActionButton";

export const EditSeatsButton = (props: {
  cartEvent: CartEvent;
  editingEventCode: string;
  onClick: (cartEvent: CartEvent) => void;
}) => {
  const { languages } = useTeamConfig();
  const changeSeatsButtonLabel = languages?.purchaseSeats?.changeSeatsButtonLabel; // prettier-ignore
  return (
    <ModalActionButton
      size={"small"}
      isLoading={props.editingEventCode == props.cartEvent?.eventCode}
      isDisabled={
        (!!props.editingEventCode &&
          props.editingEventCode !== props.cartEvent?.eventCode) ||
        props.editingEventCode === props.cartEvent?.eventCode
      }
      onClick={() => props.onClick(props.cartEvent)}
    >
      {props.cartEvent && props.cartEvent?.products?.length > 1
        ? changeSeatsButtonLabel || "Change Seats"
        : changeSeatsButtonLabel || "Change Seat"}
    </ModalActionButton>
  );
};
